import { useDispatch } from 'react-redux';
import { EVENTS, EVENT_TYPES, PARAMETERS } from '@root/tracking/constants';
import { anonymousId } from '@root/tracking/analytics';

export default function useAnalyticsEvent() {
  const dispatch = useDispatch();

  const clickToPage = (
    {
      sourcePage,
      sourceContent,
      destination,
      actionType = 'USER_NAVIGATION',
    }: {
      sourcePage?: string;
      sourceContent?: string;
      destination: string;
      actionType?: string;
    },
    otherAttrs: Object = {},
  ) => {
    dispatch({
      type: actionType,
      payload: {
        meta: {
          analytics: {
            eventType: EVENT_TYPES.track,
            event: EVENTS.clickToPage,
            sourceContent,
            sourcePage,
            destination,
            ...otherAttrs,
          },
        },
      },
    });
  };

  const mapInteraction = (
    {
      actionType,
      action,
      sourcePage,
      sourceContent,
    }: {
      actionType: string;
      action: string;
      sourcePage: string;
      sourceContent?: string;
    },
    localAttrs: Object = {},
  ) =>
    dispatch({
      type: actionType,
      payload: {
        meta: {
          analytics: {
            eventType: EVENT_TYPES.track,
            event: EVENTS.mapInteraction,
            action,
            sourcePage,
            sourceContent,
            ...localAttrs,
          },
        },
      },
    });

  const sortInteraction = ({
    actionType,
    sortValue,
    sourcePage,
  }: {
    actionType: string;
    sortValue: string;
    sourcePage: string;
  }) =>
    dispatch({
      type: actionType,
      payload: {
        meta: {
          analytics: {
            eventType: EVENT_TYPES.track,
            event: EVENTS.sortInteraction,
            sortValue,
            sourcePage,
          },
        },
      },
    });

  const areasInteraction = ({
    actionType,
    action,
    sourcePage,
    sourceContent,
  }: {
    actionType: string;
    action: string;
    sourceContent: string;
    sourcePage: string;
  }) =>
    dispatch({
      type: actionType,
      payload: {
        meta: {
          analytics: {
            eventType: EVENT_TYPES.track,
            event: EVENTS.areasInteraction,
            action,
            sourceContent,
            sourcePage,
          },
        },
      },
    });

  const galleryInteraction = ({
    actionType,
    action,
    sourcePage,
    sourceContent,
  }: {
    actionType: string;
    action: string;
    sourceContent: string;
    sourcePage: string;
  }) =>
    dispatch({
      type: actionType,
      payload: {
        meta: {
          analytics: {
            eventType: EVENT_TYPES.track,
            event: EVENTS.galleryInteraction,
            action,
            sourceContent,
            sourcePage,
          },
        },
      },
    });

  const lightboxInteraction = ({
    actionType,
    action,
    sourcePage,
    sourceContent,
  }: {
    actionType: string;
    action: string;
    sourceContent: string;
    sourcePage: string;
  }) =>
    dispatch({
      type: actionType,
      payload: {
        meta: {
          analytics: {
            eventType: EVENT_TYPES.track,
            event: EVENTS.lightboxInteraction,
            action,
            sourceContent,
            sourcePage,
          },
        },
      },
    });

  const videoInteraction = ({
    actionType,
    action,
    sourcePage,
    sourceContent,
  }: {
    actionType: string;
    action: string;
    sourceContent: string;
    sourcePage: string;
  }) =>
    dispatch({
      type: actionType,
      payload: {
        meta: {
          analytics: {
            eventType: EVENT_TYPES.track,
            event: EVENTS.videoInteraction,
            action,
            sourceContent,
            sourcePage,
          },
        },
      },
    });

  const threeDTourInteraction = ({
    actionType,
    action,
    sourcePage,
    sourceContent,
  }: {
    actionType: string;
    action: string;
    sourceContent: string;
    sourcePage: string;
  }) =>
    dispatch({
      type: actionType,
      payload: {
        meta: {
          analytics: {
            eventType: EVENT_TYPES.track,
            event: EVENTS.threeDTourInteraction,
            action,
            sourceContent,
            sourcePage,
          },
        },
      },
    });

  return {
    anonymousId: anonymousId(),
    clickToPage,
    areasInteraction,
    galleryInteraction,
    mapInteraction,
    lightboxInteraction,
    sortInteraction,
    threeDTourInteraction,
    videoInteraction,
    PARAMETERS,
  };
}
